import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Records from './pages/Records'
import DeviceManager from './pages/DeviceManger'
import Navigation from './components/Navbar/Navbar'
import Profile from './pages/Profile/Profile'
import AdminPrograms from './pages/AdminPrograms'
import Notifications from './components/Notifications/Notifcations'
import React from 'react'
import { cn } from '@/lib/utils'

function AppRoutes() {
  const { user } = useAuthContext()
  const location = useLocation()
  const authScreen = location.pathname === '/login' || location.pathname === '/signup'

  return (
    <>
      <Navigation />
      <div
        className={cn(
          'pages flex min-h-0 flex-1 flex-col',
          authScreen && 'items-center justify-center !px-4 !py-10 sm:!px-6'
        )}
      >
        <Routes>
          <Route path="/" element={user ? <Home /> : <Navigate to="/login" />} />
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />
          <Route path="/deviceManager" element={user ? <DeviceManager /> : <Navigate to="/login" />} />
          <Route path="/records" element={user ? <Records /> : <Navigate to="/login" />} />
          <Route path="/notifications" element={user ? <Notifications /> : <Navigate to="/login" />} />
          <Route path="/profile" element={user ? <Profile /> : <Navigate to="/login" />} />
          <Route
            path="/admin/programs"
            element={
              user ? user.isAdmin ? <AdminPrograms /> : <Navigate to="/" replace /> : <Navigate to="/login" />
            }
          />
        </Routes>
      </div>
    </>
  )
}

function App() {
  const { user } = useAuthContext()

  return (
    <div
      className={cn(
        'App flex min-h-screen flex-col font-sans text-foreground antialiased',
        user ? 'bg-image' : 'bg-zinc-950'
      )}
    >
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  )
}

export default App
